import styled from "styled-components";

export const QAEnvironmentPopUpBlockerInputDefaultBox = styled.input`
  display: block;
  width: 100%;
  height: 45px;
  background-color: ${({theme}) => theme.colors.backgroundDark};
  border: none;
  box-shadow: none;
  border-bottom: 1px solid ${({theme}) => theme.colors.boxBorderContrast};
  box-sizing: border-box;
  padding: 10px 40px 10px 50px;
  font-size: 16px;
  font-weight: 400;
  line-height: 100%;
  text-align: center;
  ${({theme}) => theme.font.presets.body};
  color: ${({theme}) => theme.colors.text};

`;